import useOneM1 from '@aims/shared/shared/use-one-m1';
import { gql } from '@apollo/client';
import Fuse from 'fuse.js';
import { useMemo, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { updateAnythingAction } from '../../../redux-store/anything-store';

const simpleListForUserQuery = gql`
  query SimpleList($name: String) {
    simpleListForUser(name: $name) {
      name
      list {
        _id
        key
        content
      }
      updatedAt
      updatedBy
      createdAt
      createdBy
    }
  }
`;

const searchOptions = {
  includeScore: true,
  keys: ['key'],
};

const extractSimpleList = (data) =>
  data.simpleListForUser?.list && {
    _id: 'tr-language',
    list: data.simpleListForUser?.list?.map((t) => {
      return {
        _id: t._id,
        key: t.key,
      };
    }),
  };
const queryId = 'use-languages';
const name = 'tr-language';

function useLanguages() {
  const { loading, refetch } = useOneM1({
    variables: { name: 'tr-language' },
    query: simpleListForUserQuery,
    extract: extractSimpleList,
    fetchPolicy: 'network-only',
    updateAction: updateAnythingAction,
    queryId,
  });
  const simpleList = useSelector(
    (store) => store.things[queryId]?.[name],
    shallowEqual,
  );
  const [search, setSearch] = useState();
  const languages = useMemo(() => {
    if (search) {
      const fuse = new Fuse(simpleList?.list, searchOptions);
      return fuse
        .search(search)
        .sort((a, b) => a.score - b.score)
        .map((i) => i.item);
    }
    return simpleList?.list?.sort((a, b) => a?.key?.localeCompare(b?.key));
  }, [simpleList, search]);
  return {
    languages,
    loading,
    refetch,
    search: (term) => setSearch(term),
  };
}

export default useLanguages;
